import { OrderStatusCard, StatusCardType } from '@/common/OrderStatusCard';
import OrderState from '~/constants/home/orderState';
import { RcbPurchasing } from '~/contracts/vdp';
import useUserPurchasing from '~/hooks/vdp/selectors/useUserPurchasing';
import ErrorBoundary from '~/utilities/ErrorBoundary';

export default function OrderStatusCardMapper() {
  // since user will bucketted in the spt experience, RcbPurchasing is the expected response type
  const { orderState, vehicle, openVerifications } =
    useUserPurchasing() as RcbPurchasing;

  let cardType: StatusCardType;

  switch (orderState) {
    case OrderState.OrderPlaced:
      cardType = StatusCardType.OrderPlaced;
      break;

    case OrderState.InProgress:
    case OrderState.InProgressWithTradeIn:
      cardType = StatusCardType.PurchaseInProgress;
      break;

    case OrderState.RecentlyPurchased:
      cardType = StatusCardType.Purchased;
      break;

    default:
      return null;
  }

  return (
    <ErrorBoundary key={cardType}>
      <OrderStatusCard
        cardStatus={cardType}
        orderState={orderState}
        vehicle={vehicle}
        openVerifications={openVerifications}
        nativeSource="vdp"
      />
    </ErrorBoundary>
  );
}
